<template>
    <el-drawer
        size="520px"
        :title="groupChangeDialogTitle"
        class="custom_attendance_group_drawer"
        :visible.sync="groupChangeDialogVisible"
        :close-on-press-escape="false"
        :wrapperClosable="false"
        :append-to-body="true"
        :before-close="handleDialogClose"
    >
        <div class="custom_drawer_wrap">
            <div class="drawer_form_content" v-loading="groupChangeLoading">
                <el-form
                    :model="attendanceForm"
                    :rules="attendanceFormRules"
                    label-position="top"
                    ref="attendanceForm"
                    size="small"
                >
                    <el-form-item label="班次类型" prop="type">
                        <el-radio-group @change="handleChangeDayType" v-model="attendanceForm.day_type">
                            <el-radio label="work">工作日</el-radio>
                            <el-radio label="reset">休息日</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <template v-if="attendanceForm.day_type == 'work'">
                        <el-form-item>
                            <div class="commuting">
                                <div class="commutingTop"><i>*</i>上下班时间设置</div>
                                <div class="commutingBottom">
                                    <el-form-item prop="work_time.start_time">
                                        <div class="set_time_item">
                                            <span class="set_time_item_label">上班时间：</span>
                                            <el-select
                                                :disabled="true"
                                                @change="handleChangeWorkTime"
                                                v-model="attendanceForm.work_time.start_time_type"
                                            >
                                                <el-option :value="1" label="当日"></el-option>
                                                <el-option :value="2" label="次日"></el-option>
                                            </el-select>
                                            <el-time-picker
                                                @change="handleChangeWorkTime"
                                                format="HH:mm"
                                                placeholder="选择时间"
                                                v-model="attendanceForm.work_time.start_time"
                                                value-format="HH:mm"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="work_time.end_time">
                                        <div class="set_time_item">
                                            <span class="set_time_item_label">下班时间：</span>
                                            <el-select
                                                @change="handleChangeWorkTime"
                                                v-model="attendanceForm.work_time.end_time_type"
                                            >
                                                <el-option :value="1" label="当日"></el-option>
                                                <el-option :value="2" label="次日"></el-option>
                                            </el-select>
                                            <el-time-picker
                                                @change="handleChangeWorkTime"
                                                format="HH:mm"
                                                placeholder="选择时间"
                                                v-model="attendanceForm.work_time.end_time"
                                                value-format="HH:mm"
                                            >
                                            </el-time-picker>
                                        </div>
                                    </el-form-item>

                                    <div class="line"></div>

                                    <el-form-item class="rest_time_top">
                                        <el-switch
                                            :active-value="1"
                                            :inactive-value="0"
                                            @change="handleChangeSetRset"
                                            v-model="attendanceForm.is_set_rset"
                                        ></el-switch>
                                        设置休息时间段
                                        <span>休息时间不计入工时</span>
                                    </el-form-item>

                                    <el-form-item class="rest_time_list" v-if="attendanceForm.is_set_rset == 1">
                                        <ul>
                                            <li
                                                :class="item.error ? 'el-form-item is-error' : ''"
                                                :key="index"
                                                v-for="(item, index) in attendanceForm.rest_time"
                                            >
                                                <el-select
                                                    @change="handleChangeRestTime($event, item, index)"
                                                    v-model="item.start_time_type"
                                                >
                                                    <el-option :value="1" label="当日"></el-option>
                                                    <el-option :value="2" label="次日"></el-option>
                                                </el-select>
                                                <el-time-select
                                                    :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                                    @change="handleChangeRestTime($event, item, index)"
                                                    format="HH:mm"
                                                    placeholder="选择"
                                                    v-model="item.start_time"
                                                    value-format="HH:mm"
                                                >
                                                </el-time-select>
                                                <div class="text_zhi">至</div>
                                                <el-select
                                                    @change="handleChangeRestTime($event, item, index)"
                                                    v-model="item.end_time_type"
                                                >
                                                    <el-option :value="1" label="当日"></el-option>
                                                    <el-option :value="2" label="次日"></el-option>
                                                </el-select>
                                                <el-time-select
                                                    :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"
                                                    @change="handleChangeRestTime($event, item, index)"
                                                    format="HH:mm"
                                                    placeholder="选择"
                                                    v-model="item.end_time"
                                                    value-format="HH:mm"
                                                >
                                                </el-time-select>
                                                <p class="error" v-text="item.error"></p>
                                                <span
                                                    @click="handleClickDelRest(index)"
                                                    class="del_btn"
                                                    v-if="attendanceForm.rest_time.length > 1"
                                                >
                                                    <i class="el-icon-delete"></i>
                                                </span>
                                            </li>
                                        </ul>
                                    </el-form-item>

                                    <el-form-item class="rest_time_add" v-if="attendanceForm.is_set_rset == 1">
                                        <el-button
                                            :disabled="attendanceForm.rest_time.length == 3 ? true : false"
                                            @click="handleClickAddRest"
                                            icon="el-icon-plus"
                                            size="small"
                                            type="text"
                                            >添加休息时间段</el-button
                                        >
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form-item>

                        <el-form-item class="inputNumberBox" prop="number">
                            合计工作时长<span>{{ convertToHoursAndMinutes(attendanceForm.work_hour) }}</span
                            >,计为
                            <el-input-number
                                :controls="false"
                                :max="3"
                                :min="0.5"
                                :step="0.5"
                                class="inputNumber"
                                placeholder="请输入"
                                step-strictly
                                v-model="attendanceForm.work_per_day"
                            ></el-input-number>
                            天出勤
                        </el-form-item>
                    </template>
                </el-form>
            </div>
            <div class="custom_drawer_footer">
                <el-button @click.stop="handleDialogClose" size="small" :disabled="btnDisabled">取消</el-button>
                <el-button type="primary" @click.stop="handleDialogConfirm" size="small" :disabled="btnDisabled"
                    >保存</el-button
                >
            </div>
        </div>
    </el-drawer>
</template>

<script>
export default {
    name: "AttendanceGroupChange",
    props: {
        groupChangeDialogVisible: {
            type: Boolean,
            default: false,
        },
        groupChangeDialogTitle: {
            type: String,
            default: "更改班次",
        },
        attendanceData: {
            type: Object,
            default: ()=> {}
        }
    },
    data() {
        return {
            groupChangeLoading: false,

            attendanceForm: {
                day_type: "work", //reset
                work_time: {
                    start_time: "09:00",
                    start_time_type: 1,
                    end_time: "18:00",
                    end_time_type: 1,
                },
                rest_time: [
                    {
                        start_time: "12:00",
                        start_time_type: 1,
                        end_time: "13:00",
                        end_time_type: 1,
                    },
                ],
                is_set_rset: 1,
                work_per_day: 1,
                work_hour: 8,
            },
            attendanceFormRules: {
                // name: [{required: true, message: '请输入考勤组名称'}],
                "work_time.start_time": [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            let start_time = this.attendanceForm.work_time.start_time;
                            let end_time = this.attendanceForm.work_time.end_time;
                            if (!start_time) {
                                callback(new Error("请选择上班时间"));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
                "work_time.end_time": [
                    {
                        required: true,
                        validator: (rule, value, callback) => {
                            let start_time = this.attendanceForm.work_time.start_time;
                            let end_time = this.attendanceForm.work_time.end_time;
                            if (!end_time) {
                                callback(new Error("请选择下班时间"));
                            } else if (this.calculateTotalWorkTime(this.attendanceForm.work_time) > 24) {
                                callback(new Error("上班时间不能超过24小时"));
                            } else if (
                                this.attendanceForm.work_time.end_time_type == 1 &&
                                new Date("2025-03-05 " + start_time) > new Date("2025-03-05 " + end_time)
                            ) {
                                callback(new Error("下班时间应晚于上班时间"));
                            } else {
                                callback();
                            }
                        },
                    },
                ],
            },
            btnDisabled: false,
        };
    },
    created() {
        this.attendanceForm = JSON.parse(JSON.stringify(this.attendanceData))
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:groupChangeDialogVisible", false);
        },
        handleChangeSetRset(val) {
            this.get_work_hour();
        },
        // 合计工作时长
        convertToHoursAndMinutes(hours) {
            const totalMinutes = Math.round(hours * 60); // 将小时转换为分钟并四舍五入
            const convertedHours = Math.floor(totalMinutes / 60); // 获取小时部分
            const convertedMinutes = totalMinutes % 60; // 获取分钟部分
            return `${convertedHours}小时${convertedMinutes}分`;
        },
        // 班次类型
        handleChangeDayType(val) {
            if (val == "reset") {
                this.$set(this.attendanceForm.work_time, "start_time", "00:00");
                this.$set(this.attendanceForm.work_time, "end_time", "24:00");
            } else {
                this.$set(this.attendanceForm.work_time, "start_time", "09:00");
                this.$set(this.attendanceForm.work_time, "end_time", "18:00");
            }
        },
        // 获取时长
        calculateTotalWorkTime(workTime) {
            const { start_time, start_time_type, end_time, end_time_type } = workTime;
            // 解析开始时间和结束时间
            const startTime = new Date("2025-03-05 " + start_time);
            const endTime = new Date("2025-03-05 " + end_time);
            // 计算当日工作时长
            let totalWorkTime = 0;
            if (start_time_type === 1) {
                if (end_time_type === 1) {
                    totalWorkTime += endTime - startTime; // 当日开始，当日结束
                } else if (end_time_type === 2) {
                    const nextDayEndTime = new Date("2025-03-06 " + end_time);
                    totalWorkTime += nextDayEndTime - startTime; // 当日开始，次日结束
                }
            } else if (start_time_type === 2 && end_time_type === 2) {
                const nextDayStartTime = new Date("2025-03-06 " + start_time);
                const nextDayEndTime = new Date("2025-03-06 " + end_time);
                totalWorkTime += nextDayEndTime - nextDayStartTime; // 次日开始，次日结束
            }

            // 将毫秒转换为小时
            totalWorkTime = totalWorkTime / (1000 * 60 * 60);
            return totalWorkTime;
        },
        // 上下班 时间 改变
        handleChangeWorkTime() {
            this.$refs.attendanceForm.validateField("work_time.end_time");
            this.attendanceForm.rest_time.forEach((item, key) => {
                if (this.isBreakTimeWithinWorkTime(this.attendanceForm.work_time, item) != "") {
                    this.$set(item, "error", this.isBreakTimeWithinWorkTime(this.attendanceForm.work_time, item));
                } else {
                    this.$set(item, "error", "");
                }
            });
            this.get_work_hour();
        }, //9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 01 02 03 04 05 06 07 08 09 10 11 12 13 14 15 16 17 18
        // 判断休息时间是否在上班时间范围内的函数
        isBreakTimeWithinWorkTime(workTime, restTime) {
            let start = "2025-03-05 ";
            let end = "2025-03-06 ";
            let work_start_time = new Date(
                workTime.start_time_type == 1 ? start + workTime.start_time : end + workTime.start_time
            );
            let work_end_time = new Date(
                workTime.end_time_type == 1 ? start + workTime.end_time : end + workTime.end_time
            );
            let rest_start_time = new Date(
                restTime.start_time_type == 1 ? start + restTime.start_time : end + restTime.start_time
            );
            let rest_end_time = new Date(
                restTime.end_time_type == 1 ? start + restTime.end_time : end + restTime.end_time
            );

            // 休息时间 大于 上班时间     下班时间 小于休息时间
            if (
                work_start_time.getTime() > rest_start_time.getTime() ||
                work_end_time.getTime() < rest_start_time.getTime() ||
                work_start_time.getTime() > rest_end_time.getTime() ||
                work_end_time.getTime() < rest_end_time.getTime()
            ) {
                return "休息时间段应在上下班时间范围内";
            } else if (rest_start_time.getTime() > rest_end_time.getTime()) {
                return "休息开始时间不得晚于休息结束时间";
            } else {
                return "";
            }
        },
        // 选择休息 时间
        handleChangeRestTime(value, item, index) {
            if (value && item.start_time && item.end_time) {
                let flag = true;
                if (this.isBreakTimeWithinWorkTime(this.attendanceForm.work_time, item) != "") {
                    this.$set(item, "error", this.isBreakTimeWithinWorkTime(this.attendanceForm.work_time, item));
                    flag = false;
                } else {
                    this.$set(item, "error", "");
                    flag = true;
                }
                if (flag) {
                    this.attendanceForm.rest_time.forEach((item, key) => {
                        if (key != 0 && this.isTime(this.attendanceForm.rest_time[key - 1], item, index) != "") {
                            this.$set(item, "error", this.isTime(this.attendanceForm.rest_time[key - 1], item, index));
                        } else {
                            this.$set(item, "error", "");
                        }
                    });
                }
                this.get_work_hour();
            } else {
                if (!item.start_time) {
                    this.$set(item, "error", "休息时间段开始时间为必填");
                }
                if (!item.end_time) {
                    this.$set(item, "error", "休息时间段结束时间为必填");
                }
            }
        },
        // 第 2 次休息开始时间应晚于第 1 次休息结束时间
        isTime(before, after, index) {
            let start = "2025-03-05 ";
            let end = "2025-03-06 ";
            let before_rest_start_time = new Date(
                before.start_time_type == 1 ? start + before.start_time : end + before.start_time
            );
            let before_rest_end_time = new Date(
                before.end_time_type == 1 ? start + before.end_time : end + before.end_time
            );
            let after_rest_start_time = new Date(
                after.start_time_type == 1 ? start + after.start_time : end + after.start_time
            );
            let after_rest_end_time = new Date(
                after.end_time_type == 1 ? start + after.end_time : end + after.end_time
            );

            if (before_rest_end_time > after_rest_start_time) {
                return `第 ${index + 1} 次休息开始时间应晚于第 ${index} 次休息结束时间`;
            } else {
                return "";
            }
        },
        // 合计工作时长
        get_work_hour() {
            let timelone = 0;
            if (this.attendanceForm.is_set_rset == 1) {
                this.attendanceForm.rest_time.forEach((item, key) => {
                    timelone += this.calculateTotalWorkTime(item);
                });
            }

            let work_hour = this.calculateTotalWorkTime(this.attendanceForm.work_time) - timelone;
            this.attendanceForm.work_hour = work_hour.toFixed(2);
        },
        // 添加休息时间段
        handleClickAddRest() {
            let data = {
                start_time: "",
                start_time_type: 1,
                end_time: "",
                end_time_type: 1,
            };
            this.attendanceForm.rest_time.push(data);
        },
        // 删除休息时间
        handleClickDelRest(index) {
            this.attendanceForm.rest_time.splice(index, 1);
            this.get_work_hour();
        },
        handleDialogConfirm() {
            this.$refs.attendanceForm.validate(valid => {
                    if (valid) {
                        let flag  = true
                        this.handleChangeWorkTime()
                        if(this.attendanceForm.day_type == 'work'){
                            this.attendanceForm.rest_time.forEach((item,key)=>{
                                if(this.attendanceForm.is_set_rset == 0){
                                    delete  item.error
                                }
                                if(item.error && item.error != ''){
                                    flag =false
                                }else{
                                    delete  item.error
                                }
                            })
                        }

                        if(flag){
                            let attendanceData = JSON.parse(JSON.stringify(this.attendanceForm))
                            this.$emit("callbackChangeSuccess", attendanceData)
                            this.handleDialogClose()
                            this.$message({type: 'success', message: '操作成功', duration: 1000,})
                        }
                    } else {
                        return this.$message.error('请输入必填项')
                    }
                })
        },
    },
};
</script>

<style lang="scss">
.custom_attendance_group_drawer {
    .el-drawer__header {
        padding: 16px 24px;
        margin-bottom: 0;
        border-bottom: 1px solid rgba(232, 232, 232, 1);
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(51, 51, 51, 1);
    }
}
.custom_drawer_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .drawer_form_content {
        flex: 1;
        padding: 24px;
        overflow-y: auto;
        .el-form {
            .commuting {
                width: 100%;
                border-radius: 4px;
                border: 1px solid rgba(217, 217, 217, 1);
                .commutingTop {
                    line-height: 46px;
                    background: rgba(237, 240, 244, 1);
                    padding: 0 16px;
                    box-sizing: border-box;
                    font-weight: bold;
                    font-size: 14px;
                    color: rgba(51, 51, 51, 1);
                    i {
                        color: rgba(255, 77, 79, 1);
                    }
                }
                .line {
                    width: 100%;
                    height: 1px;
                    margin: 19px 0 10px;
                    line-height: 1px;
                    display: block;
                }
                .commutingBottom {
                    padding: 16px;
                    box-sizing: border-box;
                    .set_time_item {
                        width: 100%;
                        display: flex;
                        align-items: center;
                        .set_time_item_label {
                            min-width: 70px;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                        }
                        .el-select {
                            width: 86px;
                            min-width: 86px;
                            .el-input__inner {
                                border-bottom-right-radius: 0;
                                border-top-right-radius: 0;
                            }
                        }
                        .el-date-editor {
                            width: 148px;
                            min-width: 148px;
                            .el-input__inner {
                                border-bottom-left-radius: 0;
                                border-top-left-radius: 0;
                            }
                        }
                    }
                }
                .rest_time_top {
                    width: 100%;
                    font-size: 14px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-top: 16px;
                    span {
                        color: rgba(102, 102, 102, 1);
                    }
                }
                .inputNumberBox {
                    color: rgba(51, 51, 51, 1);
                }
                .inputNumber {
                    width: 86px;
                    display: inline-block;
                }
                .rest_time_list {
                    width: 100%;
                    margin-bottom: 0 !important ;
                    li {
                        display: flex;
                        align-items: center;
                        position: relative;
                        padding-right: 32px;
                        padding-bottom: 16px;
                        margin-bottom: 0 !important;
                        .del_btn {
                            position: absolute;
                            right: 0;
                            top: 5px;
                            width: 22px;
                            height: 22px;
                            text-align: center;
                            line-height: 22px;
                            border-radius: 2px;
                            cursor: pointer;
                            &:hover {
                                background: rgba(243, 243, 243, 1);
                                color: rgba(217, 65, 67, 1);
                            }
                        }
                        .text_zhi {
                            min-width: 40px;
                            text-align: center;
                            color: rgba(51, 51, 51, 1);
                            font-size: 14px;
                        }
                        .el-select {
                            width: 80px;
                            min-width: 80px;
                            .el-input__inner {
                                border-bottom-right-radius: 0;
                                border-top-right-radius: 0;
                            }
                        }
                        .el-date-editor {
                            width: 100px;
                            min-width: 100px;
                            .el-input__inner {
                                border-bottom-left-radius: 0;
                                border-top-left-radius: 0;
                            }
                        }
                        p.error {
                            position: absolute;
                            width: 100%;
                            height: 12px;
                            line-height: 12px;
                            font-size: 12px;
                            bottom: 3px;
                            color: #f56c6c;
                        }
                    }
                }
                .rest_time_add {
                    margin-bottom: 0;
                    .el-button--text {
                        font-size: 14px;
                        font-weight: 400;
                        letter-spacing: 0px;
                        line-height: 22px;
                        color: rgba(25, 144, 255, 1);
                        padding: 0;
                        &.is-disabled {
                            color: rgba(191, 191, 191, 1);
                        }
                    }
                }
            }
        }
    }
    .custom_drawer_footer {
        padding: 10px 24px;
        border-top: 1px solid rgba(232, 232, 232, 1);
        text-align: right;
    }
}
</style>
